export default __webpack_public_path__ + "static/media/firestorm_logo.51ee34e3.png";